import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";
import { ChevronLeft, ChevronRight, Quote, Star, Sun } from "lucide-react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useEffect, useState, useRef } from "react";
import Image from "next/image";

const testimonialData = [
  {
    quote: "Excellent after-sales support and a great experience overall!",
    name: "Akshay Mahant",
    position: "Customer",
    rating: 5
  },
  {
    quote: "Firstly when choosing a solar company, it is essential to consider the quality of the solar panels and other equipment used. High-quality components ensure the durability and efficiency of your solar system, and I finally found this at Satyanam Solar.",
    name: "Amol Dode (SarKaR)",
    position: "Local Guide",
    rating: 5
  },
  {
    quote: "Satyanam Solar in Nagpur offers excellent solar energy solutions with top-notch service. Their expertise and professionalism made the entire process smooth and efficient. Highly recommended!",
    name: "Sumit Satre",
    position: "Customer",
    rating: 5
  },
  {
    quote: "Satnam Solar provided efficient, professional installation with excellent customer service. Highly recommend for solar needs.",
    name: "Vinit Mahant",
    position: "Customer",
    rating: 5
  },
  {
    quote: "High quality panels and components, installation and after service also good.",
    name: "Sushant Karad",
    position: "Customer",
    rating: 5
  },
  {
    quote: "Solar Quality is too good.",
    name: "Yash Jadhav",
    position: "Customer",
    rating: 5
  },
  {
    quote: "Give Sukhe sir a raise!",
    name: "Suhas Selokar",
    position: "Local Guide",
    rating: 5
  },
  {
    quote: "Best service.",
    name: "Gauransh Kate",
    position: "Customer",
    rating: 5
  },
];

export default function Testimonial() {
  const [isMobile, setIsMobile] = useState(false);
  const swiperRef = useRef<any>(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex flex-col gap-4 py-[4rem] px-[1.5rem] sm:px-[3rem] lg:px-[6rem]">
      {/* Header */}
      <div className="flex flex-col gap-3 mb-4">
        <div className="text-pri text-desc-size2 flex items-center gap-2">
          <Sun size={20} />
          <span>Testimonial</span>
        </div>
        <h2 className="text-text1 text-title-size3 lg:text-title-size2 md:w-[60vw] leading-[1]">
          What Our Clients Say
        </h2>
      </div>

      {/* Content */}
      <div className="flex flex-col lg:flex-row w-full items-start gap-6 py-2">
        {/* Left Column */}
        <div className="lg:w-1/4 flex lg:flex-col lg:gap-8 items-center lg:items-start justify-between">
          <h2 className="text-3xl font-semibold text-gray-800 w-2/3 lg:w-full text-left">
            Rated <span className="text-pri">5 Stars</span> by 100% of Our Happy
            Customers
          </h2>
          <div className="flex flex-row gap-2 items-end">
            <Image
              src="/home/google1.png"
              width={300}
              height={300}
              alt="G image"
              className="w-[60px] sm:w-[100px] h-auto flex"
            />
          </div>
        </div>

        {/* Swiper Slider */}
        <div className="lg:w-3/4 w-full relative">
          <Swiper
            modules={[Navigation, Autoplay, Pagination]}
            slidesPerView={isMobile ? 1 : 2}
            spaceBetween={20}
            autoplay={{ delay: 2000 }}
            loop={true}
            pagination={false}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            onSwiper={(swiper) => (swiperRef.current = swiper)}
          >
            {testimonialData.map((testimonial, index) => (
              <SwiperSlide key={index}>
                <div className="h-[370px] flex flex-col justify-between bg-white rounded-xl p-6 gap-4 shadow-lg border border-gray-300">
                  <Quote size={32} className="text-pri" />
                  <p className="text-gray-700 text-lg italic flex-grow">
                    &quot;{testimonial.quote}&quot;
                  </p>
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star 
                        key={i} 
                        size={16} 
                        className={i < testimonial.rating ? "text-yellow-500 fill-yellow-500" : "text-gray-300"} 
                      />
                    ))}
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                      {testimonial.name}
                    </h3>
                    <p className="text-gray-500 text-sm">
                      {testimonial.position}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}